import {MenuStateType} from 'appmodule/home/reducer/MenuReducer';

export const selMenuItems = (state: MenuStateType) => state.Menu.Items
export const selMenuStyle = (state: MenuStateType) => state.Menu.menuStyle
export const selMenuRefreshTS = (state: MenuStateType) => state.Menu.refreshTS